import axios from 'axios'
// LOGIN DESARROLLO**********
// export const axiosLogin = axios.create({
//   baseURL: 'https://api-preproduccion.cl:30',
//   // timeout: 3000
// })
// LOGIN PRODUCCIÓN**********
export const ToDesa = process.env.VUE_APP_BUILD_MODE === "1" ? true : false

export const axiosLogin = axios.create({
  baseURL: ToDesa ? 'https://api-preproduccion.cl:30' : 'https://api.authentic.cl',
  timeout: 5000000
})
export const MasterControlAPP = axios.create({
  // baseURL: 'https://api.centralgym.cl/atlas/mastercontrol',
  baseURL: process.env.VUE_APP_BUILD_MODE === "0" ? 'https://api.centralgym.cl/atlas/mastercontrol' : 'https://api-preproduccion.cl:33/atlas/mastercontrol',
  headers: {
    yebajJVkaZ: ToDesa
  }
  // timeout: 3000
})

export var MasterControlAPI = axios.create({
  // baseURL: 'https://api.centralgym.cl/atlas/mastercontrol',
  baseURL: !ToDesa ? 'https://api.centralgym.cl' : 'https://api-preproduccion.cl:33',
  headers: {
    'yebajJVkaZ': ToDesa
  }
  // timeout: 3000
})
export var XLSXTemplateDownload = axios.create({
  // baseURL: 'https://api.centralgym.cl/atlas/mastercontrol',
  baseURL: process.env.VUE_APP_BUILD_MODE === "0" ? 'https://api.centralgym.cl/download/template' : 'https://api-preproduccion.cl:33/download/template',
  headers: {
    'yebajJVkaZ': ToDesa
  }
})
export var DownLoadsMasterControl = axios.create({
  // baseURL: 'https://api.centralgym.cl/atlas/download',
  baseURL: !ToDesa ? 'https://api.centralgym.cl/atlas/download' : 'https://api-preproduccion.cl:33/atlas/download',
  headers: {
    'yebajJVkaZ': ToDesa
  }
  // timeout: 3000
})
export var AuthenticAPP = axios.create({
  baseURL: 'https://us-east-1.aws.data.mongodb-api.com/app/mastercontrol-axkuo/endpoint',
  // timeout: 3000
})

export var Operations = {
  Login: "user/auth/login",
  UpdatePassword: "authuser",
  UpdatePasswordOP: "/user/update/password",
  // AccessStatistics: "/v1/statistics/access",
  // MembershipsStatistics: "/v1/statistics/memberships",
  // LastCashClosings: "/v1/get/cashclosings",
  // SalesStatistics: "/v1/statistics/sales",
  // DownloadCashClosing: "/v1/download/cashclosing",
  GetConfig: "/v1/get/config"
}
export var Env = Number.parseInt(process.env.VUE_APP_BUILD_MODE)
